import React from 'react'

import { cn } from '@/shared/lib/utils'

type EmptyStateProps = {
	imageUrl?: string
	description?: string | React.ReactNode
	wrapperClasses?: string
	imgClasses?: string
	children?: React.ReactNode
}
export default ({
	imageUrl,
	description,
	wrapperClasses,
	imgClasses,
	children,
}: EmptyStateProps) => (
	<div
		className={cn(
			'justify-content-center flex w-full flex-col',
			wrapperClasses
		)}
	>
		{imageUrl && (
			<img alt='Empty' src={imageUrl} className={cn('mb-4', imgClasses)} />
		)}
		{description && (
			<p className='px-12 text-center text-sm font-medium'>{description}</p>
		)}
		{children && <div className='px-5'>{children}</div>}
	</div>
)
